import { useEffect } from "react";
import {
  initializeNativeShell,
  requestNativeNotificationPermissionOnce,
} from "../native";

export function NativeShell() {
  useEffect(() => {
    void initializeNativeShell()
      .then(() => requestNativeNotificationPermissionOnce())
      .catch(() => undefined);
  }, []);
  return null;
}
